export function convertEmptyStringAndUndefinedToNull(
  value: string | null | undefined,
): string | null {
  if (value == null) {
    return null
  }
  if (value.trim() === '') {
    return null
  }
  return value
}
